import React from "react";
import { ArrowLeft } from "lucide-react";
import RedlineLogo from "../RedlineLogo";

export const LegalLayout = ({ eyebrow, eyebrowIcon: EIcon, title, subtitle, updated, maxWidth = "max-w-4xl", children }) => {
  const back = () => { window.location.href = "/"; };
  return (
    <div className="min-h-screen bg-white text-[#1A1A1A]" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>
      <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-[#1A1A1A]/10">
        <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
          <button onClick={back} data-testid="back-to-home"
                  className="inline-flex items-center gap-2 text-sm font-medium text-[#1A1A1A]/70 hover:text-[#D32F2F] transition-colors">
            <ArrowLeft className="w-4 h-4" /> Back to Home
          </button>
          <RedlineLogo width={210} height={40} dark />
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-6 py-16 lg:py-24">
        <div className={`${maxWidth} mx-auto`}>
          <div className="mb-14">
            {eyebrow && (
              <div className="inline-flex items-center gap-2 mb-6 text-xs font-semibold uppercase tracking-[0.2em] text-[#D32F2F]">
                {EIcon ? <EIcon className="w-4 h-4" /> : <span className="w-2 h-2 bg-[#D32F2F]" />} {eyebrow}
              </div>
            )}
            <h1 className="font-head text-4xl lg:text-6xl font-extrabold tracking-tight leading-[1.02]">{title}</h1>
            {subtitle && <p className="text-lg text-[#1A1A1A]/65 mt-6 leading-relaxed max-w-3xl">{subtitle}</p>}
            {updated && <p className="text-sm text-[#1A1A1A]/40 mt-4">{updated}</p>}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export const LegalSection = ({ icon: Icon, title, children, tone = "default" }) => {
  const toneCls = tone === "accent"
    ? "bg-[#1A1A1A] text-white border-[#1A1A1A]"
    : tone === "warn"
      ? "bg-[#FBF7F0] border-amber-300/50"
      : "bg-white border-[#1A1A1A]/10";
  const titleCls = tone === "accent" ? "text-white" : "text-[#1A1A1A]";
  const bodyCls = tone === "accent" ? "text-white/75" : "text-[#1A1A1A]/70";
  return (
    <div className={`border ${toneCls} p-8 lg:p-10`}>
      {title && (
        <h2 className={`font-head text-2xl font-bold ${titleCls} flex items-center gap-3 mb-6`}>
          {Icon && (
            <span className={`w-9 h-9 flex items-center justify-center ${tone === "accent" ? "bg-[#D32F2F]" : "bg-[#D32F2F]/10"}`}>
              <Icon className={`w-5 h-5 ${tone === "accent" ? "text-white" : "text-[#D32F2F]"}`} />
            </span>
          )}
          {title}
        </h2>
      )}
      <div className={`space-y-5 ${bodyCls} leading-relaxed`}>{children}</div>
    </div>
  );
};

export const CheckList = ({ items, color = "red", cols = 1 }) => {
  const dot = color === "green" ? "bg-emerald-500"
    : color === "blue" ? "bg-blue-500"
    : color === "amber" ? "bg-amber-500"
    : "bg-[#D32F2F]";
  return (
    <ul className={`gap-x-8 gap-y-3 ${cols === 2 ? "grid sm:grid-cols-2" : "space-y-3"}`}>
      {items.map((it, i) => (
        <li key={i} className="flex items-start gap-3">
          <span className={`w-1.5 h-1.5 rounded-full ${dot} mt-2.5 shrink-0`} />
          <span>{it}</span>
        </li>
      ))}
    </ul>
  );
};
